import React from "react"


const Footer = () => {

    return (
        <div className='footer'>
            <p id="footer-issues">If you have experienced an issue or would like to contact the developer, please click <a href="mailto:gcampbell391@gmail.com">here</a></p>
            <p id="footer-issues">Copyright © Gene Campbell III 2020</p>
        </div>
    )
}

export default Footer;